import { render, staticRenderFns } from "./socialMobile4_ok.vue?vue&type=template&id=f2293914&scoped=true"
import script from "./socialMobile4_ok.vue?vue&type=script&lang=js"
export * from "./socialMobile4_ok.vue?vue&type=script&lang=js"
import style0 from "./socialMobile4_ok.vue?vue&type=style&index=0&id=f2293914&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2293914",
  null
  
)

export default component.exports